module.exports = __webpack_public_path__ + "img/contacts.0d193b6f.svg";